import '@fontsource/montserrat';
import './src/styles/_reset.scss';
import './src/styles/_colors.scss';
import './src/styles/_global-style.scss';
import './src/styles/_markdown-style.scss';
import 'katex/dist/katex.min.css';
